"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagService = void 0;
const isEnvConfig = (feature) => {
    return (!!feature &&
        typeof feature === 'object' &&
        'dev' in feature &&
        'qa' in feature &&
        'stage' in feature &&
        'prod' in feature);
};
class FeatureFlagService {
    featureFlagsConfig;
    environment;
    constructor(featureFlagsConfig, environment) {
        this.featureFlagsConfig = featureFlagsConfig;
        this.environment = environment;
    }
    isFeatureEnabled(featureName) {
        const feature = this.featureFlagsConfig[featureName];
        if (typeof feature === 'boolean' || this.environment === undefined) {
            return !!feature;
        }
        if (isEnvConfig(feature)) {
            return feature[this.environment] || false;
        }
        throw new Error(`잘못된 feature flag 입니다. flag: ${featureName}`);
    }
}
exports.FeatureFlagService = FeatureFlagService;
